module.exports = __webpack_public_path__ + "img/occitanie.e2b03265.jpg";